export default "__VITE_ASSET__5gM1oN56__"